import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "app/shadcnComponents/ui/tooltip";

export default function SubSectionHeader({
  title,
  count,
  tooltip,
}: Readonly<{
  title: string;
  count: number;
  tooltip?: string;
}>) {
  return (
    <div className="flex items-center gap-1.5 px-6 pt-2.5 pb-1">
      <span className="text-[11px] font-medium text-charcoal-80">
        {title} ({count})
      </span>
      {tooltip && (
        <TooltipProvider delayDuration={150}>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type="button"
                aria-label={`About ${title}`}
                className="inline-flex items-center justify-center text-charcoal-60 hover:text-charcoal-100 cursor-help focus:outline-none focus-visible:ring-1 focus-visible:ring-sapphire-60 rounded"
              >
                <FontAwesomeIcon icon={faCircleInfo} className="text-[14px]" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="bottom" align="start" className="w-60">
              {tooltip}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}
